<template>
    <div>
        <h1>Scratch tips</h1>
        <nav>
            <router-link to="/tips-og-tricks/scratch-101">Scratch 101</router-link>
            |
            <router-link to="/tips-og-tricks/help">Scratch-hjælp</router-link>
            |
            <router-link to="/tips-og-tricks/scratch-projekter">Scratch projekter</router-link>
            |
            <router-link to="/tips-og-tricks/links">Nyttige links</router-link>
        </nav>
        <router-view></router-view>
    </div>
</template>

<script>
import EmbedScratch from '@/components/ScratchEmbed';
export default {
  name: 'Links',
  components: {
    EmbedScratch
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/tips-og-tricks/index.vue